var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4392)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 42H59.5C60.2957 42 61.0587 41.6839 61.6213 41.1213C62.1839 40.5587 62.5 39.7956 62.5 39V30C62.5 29.2044 62.1839 28.4413 61.6213 27.8787C61.0587 27.3161 60.2957 27 59.5 27H50.5C49.7044 27 48.9413 27.3161 48.3787 27.8787C47.8161 28.4413 47.5 29.2044 47.5 30V33H46C44.4087 33 42.8826 33.6321 41.7574 34.7574C40.6321 35.8826 40 37.4087 40 39V43.5H34V42C34 41.2044 33.6839 40.4413 33.1213 39.8787C32.5587 39.3161 31.7956 39 31 39H25C24.2044 39 23.4413 39.3161 22.8787 39.8787C22.3161 40.4413 22 41.2044 22 42V48C22 48.7956 22.3161 49.5587 22.8787 50.1213C23.4413 50.6839 24.2044 51 25 51H31C31.7956 51 32.5587 50.6839 33.1213 50.1213C33.6839 49.5587 34 48.7956 34 48V46.5H40V51C40 52.5913 40.6321 54.1174 41.7574 55.2426C42.8826 56.3679 44.4087 57 46 57H47.5V60C47.5 60.7957 47.8161 61.5587 48.3787 62.1213C48.9413 62.6839 49.7044 63 50.5 63H59.5C60.2957 63 61.0587 62.6839 61.6213 62.1213C62.1839 61.5587 62.5 60.7957 62.5 60V51C62.5 50.2044 62.1839 49.4413 61.6213 48.8787C61.0587 48.3161 60.2957 48 59.5 48H50.5C49.7044 48 48.9413 48.3161 48.3787 48.8787C47.8161 49.4413 47.5 50.2044 47.5 51V54H46C45.2044 54 44.4413 53.6839 43.8787 53.1213C43.3161 52.5587 43 51.7956 43 51V39C43 38.2044 43.3161 37.4413 43.8787 36.8787C44.4413 36.3161 45.2044 36 46 36H47.5V39C47.5 39.7956 47.8161 40.5587 48.3787 41.1213C48.9413 41.6839 49.7044 42 50.5 42ZM31 48H25V42H31V48ZM50.5 51H59.5V60H50.5V51ZM50.5 30H59.5V39H50.5V30Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4392",
    x1: 0,
    y1: 45.5,
    x2: 90,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR2);
export default __webpack_public_path__ + "static/media/r-2.06b3ca4f372998a6455e4385a75fd667.svg";
export { ForwardRef as ReactComponent };